import BackButton from "./BackButton";

function BodyContainer({content, usingSidePadding = true, showBackButton = false}) {
    return (
        <>

            <div className={`main-container ${showBackButton && "back-button"}`}>
                { showBackButton &&
                    <div className={`main-back-button-container`}>
                        <BackButton/>
                    </div>
                }
                <div className={`body-container ${usingSidePadding ? "side-padding" : ""}`}>
                    {content}
                </div>
            </div>
        </>

    )
}

export default BodyContainer;